import React, { useState } from 'react'
import classNames from 'classnames'

import { LntModal, LntUploadDragger, LntButton, LntSpin, LntModalFooter, LntProgress } from '@app/components/base'
import { Show } from '@app/components/util'

import { isEmptyArray } from '@app/utils'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { usePhotosUpload } from './hooks'

import styles from './styles.module.scss'

import type { UploadPhotosModalProps } from './types'

const ACCEPTED_FILE_TYPES = 'image/jpeg'

export const PhotosUploadModal: React.FC<UploadPhotosModalProps> = ({
  taskId,
  onCancel,
  onPhotosUploadFinish,
  ...restProps
}) => {
  const [photosList, setPhotosList] = useState<File[]>([])

  const clearPhotosList = (): void => {
    setPhotosList([])
  }

  const { isUploading, percent, upload: handlePhotosUpload } = usePhotosUpload({ taskId, onPhotosUploadFinish })

  const infoClassName = classNames(styles.downloadFilesModal__info, styles.downloadFilesModal__info_floating)

  const handleBeforeUpload = (file: File): boolean => {
    /**
     *  TODO:
     *    потенциально может быть bottleneck из-за частого изменения стейта
     *    но похоже в реакт хорошо работает state batching
     *    если при использовании этой модалки будут проблемы
     *    то тут нужно будет ввести троттлинг изменения стейта
     * */
    setPhotosList(prevPhotosList => [...prevPhotosList, file])

    return false
  }

  const handleUploadPhotos = (): void => {
    handlePhotosUpload?.(photosList)
  }

  const handleClose = (): void => {
    if (isUploading) return

    onCancel?.()
  }

  return (
    <LntModal
      { ...restProps }
      footer={ null }
      className={ styles.downloadFilesModal }
      afterClose={ clearPhotosList }
      onCancel={ handleClose }
    >
      <LntSpin spinning={ isUploading }>
        <LntUploadDragger
          multiple
          directory
          accept={ ACCEPTED_FILE_TYPES }
          disabled={ isUploading }
          showUploadList={ false }
          beforeUpload={ handleBeforeUpload }
        >
          <div className={ styles.downloadFilesModal__dragger }>
            <p className={ styles.downloadFilesModal__info }>Перетащите папку с фото сюда или нажмите кнопку ниже</p>

            <LntButton
              type={ BUTTON_TYPE.primary }
              size={ SIZE.small }
              disabled={ isUploading }
              className={ styles.downloadFilesModal__buttons }
            >
              Выбрать папку
            </LntButton>

            <Show condition={ photosList.length > 0 }>
              <p className={ infoClassName }>Кол-во выбранных файлов: { photosList.length }</p>
            </Show>
          </div>
        </LntUploadDragger>
      </LntSpin>

      <LntProgress
        className={ styles.downloadFilesModal__progress }
        status={ isUploading ? 'active' : undefined }
        percent={ percent }
      />

      <LntModalFooter className={ styles.downloadFilesModal__footer }>
        <LntButton
          type='text'
          disabled={ isUploading }
          onClick={ handleClose }
        >
          Отмена
        </LntButton>

        <LntButton
          disabled={ isUploading || isEmptyArray(photosList) }
          onClick={ handleUploadPhotos }
        >
          Загрузить
        </LntButton>
      </LntModalFooter>
    </LntModal>
  )
}
